module.exports = __webpack_public_path__ + "static/media/inspiration.d00e0154.jpg";